// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ShippingDetailsModal__wrapper__a294d323"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal.scss
// module id = 1836
// module chunks = 7 16